import React, { createContext, useState, useEffect } from 'react';
import all_product from '../Components/Assets/all_product';

// Create context
export const ShopContext = createContext(null);

// Function to generate default cart
const getDefaultCart = () => {
    let cart = {};
    for (let index = 0; index < all_product.length + 1; index++) {
        cart[index] = 0;
    }
    return cart;
}

// ShopContextProvider component
const ShopContextProvider = (props) => {
    // State for cart items
    const [cartItems, setCartItems] = useState(getDefaultCart());

    // Function to add item to cart
    const addToCart = (itemId) => {
        // Update cartItems state with the new value
        setCartItems((prev) => ({ ...prev, [itemId]: prev[itemId] + 1 }));

        // Make API call to add item to cart
        if (localStorage.getItem('auth-item')) {
            fetch('http://localhost:4000/addtocart', {
                method: 'POST',
                headers: {
                    Accept: 'application/form-data',
                    'auth-token': localStorage.getItem('auth-token'),
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ itemId: itemId })
            })
            .then((response) => response.json())
            .then((data) => console.log(data));
        }
    }

    // Function to remove item from cart
    const removeToCart = (itemId) => {
        setCartItems((prev) => ({ ...prev, [itemId]: prev[itemId] - 1 }));
    }

    const getTotalCartAmount = () => {
        let totalAmount = 0;
        for (const item in cartItems) {
            if (cartItems[item] > 0) {
                let itemInfo = all_product.find((product) => product.id === Number(item));
                totalAmount += itemInfo.new_price * cartItems[item];
            }
        }
        return totalAmount;
    }

    const getTotalCartItems = () => {
        let totalItem = 0;
        for (const item in cartItems) {
            if (cartItems[item] > 0) {
                totalItem += cartItems[item];
            }
        }
        return totalItem;
    }

    useEffect(() => {
        console.log(cartItems);
    }, [cartItems]);

    // Context value containing all products, cart items, and functions for adding/removing from cart
    const contextValue = { getTotalCartItems, getTotalCartAmount, all_product, cartItems, addToCart, removeToCart };

    // Provide context value to children components
    return (
        <ShopContext.Provider value={contextValue}>
            {props.children}
        </ShopContext.Provider>
    );
}

// Export ShopContextProvider component
export default ShopContextProvider;
